// src/docs/DocsNavigation.js
import React from "react";
import { Container, Typography } from "@mui/material";

const DocsNavigation = () => {
  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      {/* Title */}
      <Typography variant="h5" sx={{ color: "#FFD700", mb: 2 }}>
        Platform Navigation & Menu
      </Typography>
      
      {/* Introduction */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mb: 2 }}>
        CrowdLaunch features a streamlined navigation menu designed to help you quickly access all key functionalities on the platform. Whether you’re exploring share sales, managing your holdings, or navigating to project management tools, the menu provides an intuitive and responsive interface.
      </Typography>
      
      {/* Menu Structure */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Menu Structure
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        The main menu is organized into clear sections, including:
        <br />• <strong>Dashboard :</strong> Get a snapshot of the general project statistics on CrowdLaunch.
        <br />• <strong>Swap</strong> Swap between LNCH and BNB Allowing users easy access to LNCH tokens to fuel all their platform activities.
        <br />• <strong>Staking & Rewards:</strong> Manage staking and pool, view your rewards, and track performance.
        <br />• <strong>Project Management:</strong> Monitor and manage your deployed projects.
        <br />• <strong>Tokenize:</strong> Access to our Tokenization tab allowing users to view and create tokenized projects, purchase project shares, and list project shares.
        <br />• <strong>Manage:</strong> Manage deployed projects and their associated details. Keep projects current and inintializes finalize sale. 

      </Typography>
      
      
      {/* Conclusion */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mt: 3 }}>
        The Platform Navigation & Menu are central to ensuring that you can efficiently access all features of CrowdLaunch. Their design promotes both functionality and a pleasant user experience, making it easier to manage your projects and investments.
      </Typography>
    </Container>
  );
};

export default DocsNavigation;
